import { Fragment, useState, useRef, useEffect } from "react";
import { Row, Col, Card, Button, Modal, Badge, Input } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import "react-aspect-ratio/aspect-ratio.css";
import "../../style.css";
import "../../globalStyles.css";
import data from "../../../constants/restaurantPos.json";
import { htmlPrint } from "../../../lib/printer/htmlPrinter";
import retailData from "../../../constants/retailPos.json";
import TimerIcon from "../../../assets/images/timer-icon.svg";
import MobileIcon from "../../../assets/images/mobileIcon.svg";
import defaultImage from "../../../assets/images/no-image.svg";
import groupBy from "lodash/groupBy";
import sumBy from "lodash/sumBy";
import { useHistory } from "react-router-dom";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import RefundIcon from "../../../assets/images/refund.svg";
import PrintIcon from "../../../assets/images/print.svg";
import ok from "../../../assets/images/tick.svg";
import Backspace from "../../../assets/images/backspac.png";
import AspectRatio from "react-aspect-ratio";
import TextArea from "rc-textarea";
import Axios from "axios";
import db from "../../../database";
import { getMultilingualText } from "../../../utils/getMultilingualText";
import useAuthStore from "../../../stores/useAuthStore";
import useRestaurantStore from "../../../stores/useRestaurantStore";
import { notifyTemplateNotConfigured, PRINT_TEMPLATES } from "../../../lib/printer/printTemplateErrors";

const PointOfSaleRestaurantModals = (props) => {
  const tillData = useAuthStore((s) => s.tillData);
  const ObFlag = tillData.tillAccess.cwrTill.printTemplate.obController === "Y" ? true : false;
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const {
    selectedItemsModalOpen,
    setSelectedItemsModalOpen,
    selectProductInCart,
    handleDisplayOk,
    barcodeOrderStatusModal,
    setBarcodeOrderStatusModal,
    barcodeOrderList,
    handleBarcodeOrderPrint,
    handleAccept,
    cart,
    openPaymentModal,
    billConfirmationModalOpen,
    setBillConfirmationModalOpen,
    managementScreenShow,
    setManagementScreenShow,
    orderTypeSelection,
    loyalityOtpModalVisible,
    setLoyalityOtpModalVisible,
    setLoyaltyPaymentOtp,
    processOtpInput,
    loyaltyPaymentOtp,
    showSendToKitchen,
    setShowSendToKitchen,
    getCustomerData,
    orderFlags,
    setOrderFlags,
    selectedTable,
    orderedData,
    fireMode,
    setFireMode,
    pendingFireItems,
    setPendingFireItems,
    setCart,
  } = props;
  // UI-only feedback for the Confirm button below. The actual re-entrancy
  // guard lives in handleDisplayOk itself (useOrderHandlers.js) via a ref —
  // this state just disables the button so a slow response doesn't invite a
  // second tap in the first place.
  const [confirmFiring, setConfirmFiring] = useState(false);
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const toFixedTruncate = (num, decimalPlaces = 3) => {
    if (isNaN(num) || num === null) num = 0;
    const factor = Math.pow(10, decimalPlaces);
    const truncatedNum = Math.trunc(num * factor) / factor;
    return truncatedNum.toFixed(decimalPlaces);
  };
  const PrintThroughHC = (printReciptData) => {
    const printerURL = tillData.tillAccess.cwrTill.hardwareController.imageUrl;
    let tableDetails = useRestaurantStore.getState().tableName;
    let salesRep = tillData.tillAccess.csBunit.salesRep.filter((item) => item.salesRepresentId === tableDetails?.waiter);
    if (salesRep.length > 0) {
      printReciptData.waiter = salesRep[0]?.name;
    }
    const mergedData = printReciptData.items.reduce((result, item) => {
      const existingItem = result.find((i) => i.productId === item.productId && item.canceled !== "Y");
      if (existingItem) {
        existingItem.weight += item.weight;
        existingItem.nettotal += item.nettotal;
      } else if (item.canceled !== "Y") {
        result.push({ ...item });
      }
      return result;
    }, []);
    printReciptData.items = mergedData;
    let customerFlag = false;
    let Payments1;
    printReciptData.payments.map((item) => {
      if (item.name === "Credit") {
        customerFlag = true;
      }
      Payments1 += `
  <line>
      <text align="left" length="13"> ${item.name}</text>
      <text align="left" length="13">${item.amount}</text>
      <text align="left" length="13">${item.isoCode}</text>
  </line>`;
    });
    const currenciesList = tillData.tillAccess.csBunit.currencies;
    let THB = tillData.tillAccess.csBunit.currencies[0].conversions.filter((item) => item.isoCode === "THB");
    const discountAmount =
      currenciesList[0].isoCode === "USD"
        ? parseFloat((printReciptData?.discount || 0).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
        : currenciesList[0].isoCode === "LAK"
          ? parseFloat((printReciptData?.discount || 0).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("lo-LA")
          : currenciesList[0].isoCode === "INR"
            ? parseFloat((printReciptData?.discount || 0).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-IN")
            : currenciesList[0].isoCode === "EUR"
              ? parseFloat((printReciptData?.discount || 0).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-GB")
              : currenciesList[0].isoCode === "AED"
                ? parseFloat((printReciptData?.discount || 0).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("ar-AE")
                : parseFloat((printReciptData?.discount || 0).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US");
    let USD = tillData.tillAccess.csBunit.currencies[0].conversions.filter((item) => item.isoCode === "USD");
    let EUR = tillData.tillAccess.csBunit.currencies[0].conversions.filter((item) => item.isoCode === "EUR");
    let CNY = tillData.tillAccess.csBunit.currencies[0].conversions.filter((item) => item.isoCode === "CNY");
    let itemsDetails = "";
    let discountDetails = "";
    let staffDetails = "";

    printReciptData.items.forEach((item) => {
      itemsDetails += `
      
  <line>
      <text align="left" length="20"> ${item.name.substring(0, 15).replace(/&/g, "&amp;")}</text>
      <text align="left" length="7">${item.salePrice}</text>
      <text align="center" length="6">${item.weight}</text>
      <text align="left" length="9">${item.nettotal}</text>
  </line>
  <line>
          <text align="left" length="20"> ${item.name.substring(15, 30).replace(/&/g, "&amp;")}</text>
      </line>
      <line>
          <text align="left" length="20"> ${item.name.substring(30).replace(/&/g, "&amp;")}</text>
      </line>
  
        `;
    });
    if (customerFlag) {
      staffDetails += ` <line><text align="left" length="30" > Staff:@@staff@@</text></line>`;
    }

    const groupAndSumItems = (items) => {
      const groupedItems = {};
      items.forEach((item) => {
        if (groupedItems.hasOwnProperty(item.discountName)) {
          groupedItems[item.discountName].value += item.value;
        } else if (parseFloat(item.discount) > 0) {
          groupedItems[item.discountName] = {
            discountName: item.discountName,
            discount: item.discount,
          };
        }
      });
      return Object.values(groupedItems);
    };

    const result = groupAndSumItems(printReciptData.items);

    if (result.length > 0) {
      discountDetails += result
        .map((data) => {
          return `<line><text align="left" length="20"> ${data.discountName}</text><text align="left" length="10">${data.discount}</text></line>`;
        })
        .join("");

      discountDetails += `<line> <text>---------------------------------------------</text> <text align="center" length="42">----------------------------------------------------</text> </line>`;
    }
    let decodedData = tillData?.tillAccess?.cwrTill?.printTemplate?.xmlcode2;
    if (!decodedData) {
      notifyTemplateNotConfigured(PRINT_TEMPLATES.sales, "Bill");
      return;
    }
    decodedData = decodedData.replaceAll(
      "@@date@@",
      `${printReciptData.salesHistory === "Y" ? printReciptData.orderTime.substring(0, 10) : new Date().toLocaleString().substring(0, 10)}`
    );
    decodedData = decodedData.replaceAll("@@printReciptDataDocumentno@@", `${printReciptData.documentno ? printReciptData.documentno : ""}`);
    decodedData = decodedData.replaceAll(
      "@@waiterName@@",
      `${
        printReciptData.salesHistory === "Y"
          ? printReciptData.waiter !== null && printReciptData.waiter !== undefined
            ? printReciptData.waiter
            : ""
          : salesRep[0]?.name === undefined && salesRep[0]?.name == null
            ? ""
            : salesRep[0]?.name
      }`
    );
    decodedData = decodedData.replaceAll("@@staffDetails@@", ``);
    decodedData = decodedData.replaceAll("@@staff@@", `${customerFlag ? printReciptData.customer.name : ""}`);
    decodedData = decodedData.replaceAll(
      "@@NoofGuests@@",
      `${
        printReciptData.salesHistory === "Y"
          ? printReciptData.noOfPersons !== null
            ? printReciptData.noOfPersons
            : ""
          : tableDetails?.noOfPersons === null
            ? ""
            : tableDetails?.noOfPersons
      }`
    );
    decodedData = decodedData.replaceAll(
      "@@TableName@@",
      `${printReciptData.salesHistory === "Y" ? (printReciptData.table !== null ? printReciptData.table : "") : tableDetails?.table === null ? "" : tableDetails?.table}`
    );
    decodedData = decodedData.replaceAll(
      "@@Time@@",
      `${printReciptData.salesHistory === "Y" ? printReciptData.orderTime.substring(10, printReciptData.orderTime.length - 1) : new Date().toLocaleTimeString()}`
    );
    decodedData = decodedData.replaceAll("@@itemsDetails@@", `${itemsDetails}`);
    decodedData = decodedData.replaceAll("@@discountDetails@@", `${discountDetails}`);
    decodedData = decodedData.replaceAll("@@discountAmount@@", `${discountAmount}`);
    decodedData = decodedData.replaceAll(
      "@@KIP@@",
      `${
        currenciesList[0].isoCode === "USD"
          ? parseFloat(printReciptData.total.toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
          : currenciesList[0].isoCode === "LAK"
            ? parseFloat(printReciptData.total.toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("lo-LA")
            : currenciesList[0].isoCode === "INR"
              ? parseFloat(printReciptData.total.toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-IN")
              : currenciesList[0].isoCode === "EUR"
                ? parseFloat(printReciptData.total.toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-GB")
                : currenciesList[0].isoCode === "AED"
                  ? parseFloat(printReciptData.total.toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("ar-AE")
                  : parseFloat(printReciptData.total.toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
      }`
    );
    decodedData = decodedData.replaceAll(
      "@@THB@@",
      `${
        currenciesList[0].isoCode === "USD"
          ? parseFloat((printReciptData.total * THB[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
          : currenciesList[0].isoCode === "LAK"
            ? parseFloat((printReciptData.total * THB[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("lo-LA")
            : currenciesList[0].isoCode === "INR"
              ? parseFloat((printReciptData.total * THB[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-IN")
              : currenciesList[0].isoCode === "EUR"
                ? parseFloat((printReciptData.total * THB[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-GB")
                : currenciesList[0].isoCode === "AED"
                  ? parseFloat((printReciptData.total * THB[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("ar-AE")
                  : parseFloat((printReciptData.total * THB[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
      }`
    );
    decodedData = decodedData.replaceAll(
      "@@USD@@",
      `${
        currenciesList[0].isoCode === "USD"
          ? parseFloat((printReciptData.total * USD[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
          : currenciesList[0].isoCode === "LAK"
            ? parseFloat((printReciptData.total * USD[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("lo-LA")
            : currenciesList[0].isoCode === "INR"
              ? parseFloat((printReciptData.total * USD[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-IN")
              : currenciesList[0].isoCode === "EUR"
                ? parseFloat((printReciptData.total * USD[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-GB")
                : currenciesList[0].isoCode === "AED"
                  ? parseFloat((printReciptData.total * USD[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("ar-AE")
                  : parseFloat((printReciptData.total * USD[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
      }`
    );
    decodedData = decodedData.replaceAll(
      "@@EUR@@",
      `${
        currenciesList[0].isoCode === "EUR"
          ? parseFloat((printReciptData.total * EUR[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
          : currenciesList[0].isoCode === "LAK"
            ? parseFloat((printReciptData.total * EUR[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("lo-LA")
            : currenciesList[0].isoCode === "INR"
              ? parseFloat((printReciptData.total * EUR[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-IN")
              : currenciesList[0].isoCode === "EUR"
                ? parseFloat((printReciptData.total * EUR[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-GB")
                : currenciesList[0].isoCode === "AED"
                  ? parseFloat((printReciptData.total * EUR[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("ar-AE")
                  : parseFloat((printReciptData.total * EUR[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
      }`
    );
    decodedData = decodedData.replaceAll(
      "@@CNY@@",
      `${
        currenciesList[0].isoCode === "CNY"
          ? parseFloat((printReciptData.total * CNY[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
          : currenciesList[0].isoCode === "LAK"
            ? parseFloat((printReciptData.total * CNY[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("lo-LA")
            : currenciesList[0].isoCode === "INR"
              ? parseFloat((printReciptData.total * CNY[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-IN")
              : currenciesList[0].isoCode === "CNY"
                ? parseFloat((printReciptData.total * CNY[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-GB")
                : currenciesList[0].isoCode === "AED"
                  ? parseFloat((printReciptData.total * CNY[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("ar-AE")
                  : parseFloat((printReciptData.total * CNY[0]?.currencyToRate).toFixed(roundOffValue[0]?.prcPrecision)).toLocaleString("en-US")
      }`
    );
    decodedData = decodedData.replaceAll("@@Payments1@@", `${Payments1}`);
    decodedData = decodedData.replaceAll("@@Payment Status@@", "");

    Axios.post(`${printerURL}printer`, decodedData, {
      headers: {
        "Content-Type": "application/xml; charset=UTF-8",
        Accept: "application/xml",
      },
    })
      .then(() => {
      })
      .catch((response) => {
      });
  };
  const handleBillPrint = async () => {
    let selectedTable = useRestaurantStore.getState().tableName;
    await db.fbOrderData
      .where("cwrFbTableId")
      .equals(selectedTable?.cwrFbTableId)
      .toArray()
      .then((ordersFetched) => {
        if (ordersFetched.length > 0) {
          let newData = ordersFetched.sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime));
          if (newData[0].fbOrderStatus === "IP") {
            newData[0].cart["orderSelection"] = orderTypeSelection;
            if (ObFlag) {
              PrintThroughHC(newData[0].cart, "Receipt", 1);
            } else {
              htmlPrint(newData[0].cart, "Receipt", 1);
            }
          }
        }
      });
    setBillConfirmationModalOpen(false);
  };

  const history = useHistory();
  const [refundModalShow, setRefundModalShow] = useState(false);
  const [refundConfirmModalShow, setRefundConfirmModalShow] = useState(false);
  const [refundRemarksModalShow, setRefundRemarksModalShow] = useState(false);
  const [keypadInput, setKeypadInput] = useState("");
  const [layout, setLayout] = useState("default");
  const keyboard = useRef();
  const [weight, setWeight] = useState("");
  const [roundOffValue, setRoundOffValue] = useState(0);

  useEffect(() => {
    let tempArray = [];
    {
      Object.entries(groupBy(cart?.items || [], "productCategoryName")).map(([key, value]) => {
        let flag = "N";
        value.map((item) => {
          if (item.order === "N") {
            flag = "Y";
          }
        });
        tempArray.push(flag);
      });
    }
    setOrderFlags(tempArray);
  }, [selectedItemsModalOpen]);

  const onChangeWeight = (event) => {
    setWeight(event.target.value);
  };

  const handleWeight = (value) => {};

  const addQuantity = () => {};

  const handleKeyboardInputs = (value) => {
    setKeypadInput(value);
  };

  const handleShift = () => {
    const newLayoutName = layout === "default" ? "shift" : "default";
    setLayout(newLayoutName);
  };

  const handleKeyPress = (button) => {
    if (button === "{shift}" || button === "{lock}") handleShift();
  };

  const handleRemarksValue = (event) => {
    const keyboardInput = event.target.value;
    setKeypadInput(keyboardInput);
    keyboard.current.setKeypadInput(keyboardInput);
  };

  return (
    <Fragment>
      <Modal
        className="fire-confirm-modal"
        open={selectedItemsModalOpen}
        closable={false}
        footer={null}
        width="50%"
        centered
        styles={{ body: { padding: 10, maxHeight: "400px" } }}
        onCancel={() => setSelectedItemsModalOpen(false)}
      >
        <Row className="fire-confirm-header-row">
          <Col span={12}>
            <p className="fire-confirm-modal-title" style={data.restaurantPos.content.selectedItemsDisplayModal.title}>Order Items</p>
          </Col>
        </Row>
        <Card className="fire-confirm-items-card" styles={{ body: { padding: 10 } }} style={data.restaurantPos.content.selectedItemsDisplayModal.selectedItemsCard}>
          <Scrollbars autoHide className="selectedItemsScroll">
            {Object.entries(groupBy(orderedData || [], "productCategoryName")).map(([key, value], ind) => (
              <div style={data.restaurantPos.content.orderCart.thirdRow}>
                {/* FIX: ALWAYS SHOW CATEGORY HEADER */}
                {/* <Row>
                  <p style={data.restaurantPos.content.orderCart.productCategory}>{key || "Others"}</p>
                </Row> */}

                {value?.map((item) => {
                  return (
                    <div
                      style={{
                        padding: "5px 0px",
                        cursor: "pointer",
                      }}
                    >
                      <Row className="fire-confirm-item-row" onClick={() => selectProductInCart(item)} style={{ fontSize: "1vw" }}>
                        {/* your item UI unchanged */}

                        <Col span={13}>
                          <p style={data.restaurantPos.content.orderCart.productDetails}>{item?.productAliasName ? item?.productAliasName : item.name}</p>

                          {item?.selectedAddons?.map((subitem) => (
                            <div
                              style={{
                                display: "flex",
                                width: "80%",
                                paddingLeft: "6px",
                              }}
                            >
                              <span style={{ flex: 1, ...data.restaurantPos.content.orderCart.modifier }}>{subitem.name}</span>

                              <span style={{ flex: 1, textAlign: "right", ...data.restaurantPos.content.orderCart.modifierPrice }}>+ {subitem.price}</span>
                            </div>
                          ))}

                          <div
                            style={{
                              display: "flex",
                              width: "80%",
                              paddingLeft: "6px",
                              marginTop: "2px",
                            }}
                          >
                            <span style={{ flex: 1, ...data.restaurantPos.content.orderCart.modifier }}>{item.saleType === "DI" ? "Dine In" : "Take Away"}</span>

                            <span style={{ flex: 1, textAlign: "right", ...data.restaurantPos.content.orderCart.modifier }}>{item.productionCenter || ""}</span>
                          </div>
                        </Col>

                        <Col span={6}>
                          <p style={data.restaurantPos.content.orderCart.productDetails}>
                            <Row>
                              <Col span={10} style={{ color: "#2F3856" }}>
                                {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""} {Number(sumBy(item?.selectedAddons, "price") || 0) + item.realPrice}{" "}
                                {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                              </Col>
                              <Col span={2}>X</Col>
                              <Col span={9}>
                                <span style={data.restaurantPos.content.orderCart.productQty}>
                                  <span style={data.restaurantPos.content.orderCart.productDetails}>{item.weight || item.sendQty || item.firedQty}</span>
                                </span>
                              </Col>
                            </Row>
                          </p>
                        </Col>

                        <Col span={4} style={data.restaurantPos.content.orderCart.amtTextAlign}>
                          <p style={{ color: "#2F3856", fontWeight: 600, fontSize: "1em" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {toFixedTruncate(item.nettotal, pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                          </p>
                        </Col>

                        {item.notes && item.notes.length > 0 && (
                          <span
                            style={{
                              fontSize: "0.6rem",
                              fontWeight: 400,
                              color: "#929098",
                            }}
                          >
                            Special Instructions: {item.notes}
                          </span>
                        )}
                      </Row>
                    </div>
                  );
                })}
              </div>
            ))}
          </Scrollbars>
        </Card>
        <Row className="fire-confirm-footer-row" style={data.restaurantPos.content.selectedItemsDisplayModal.okCancelBtns}>
          <Button
            size="large"
            className="customerDetailsCancelBtn"
            style={data.restaurantPos.content.selectedItemsDisplayModal.selectedItemsCancelBtn}
            onClick={() => setSelectedItemsModalOpen(false)}
          >
            {getMultilingualText("Cancel")}
          </Button>
          <Button
            size="large"
            disabled={confirmFiring}
            loading={confirmFiring}
            style={data.restaurantPos.content.selectedItemsDisplayModal.selectedItemsSubmitBtn}
            onClick={async () => {
              // This is the actual submit — the button that fires the async
              // upsertFBOrder mutation. BUG-1993/1997: two taps here (rage-tap,
              // or a slow-network retry) each ran handleDisplayOk concurrently
              // and minted two different server line IDs for the same item.
              // The outer "Fire All to Kitchen" button's own guard doesn't
              // cover this — it only wraps opening this modal, not this click.
              if (confirmFiring) return;
              setConfirmFiring(true);
              try {
                const newCart = {
                  ...cart,
                  items: cart.items.map((item) => {
                    const wasFired = pendingFireItems.find((p) => p.lineId === item.lineId);
                    if (wasFired) {
                      return {
                        ...item,
                        order: "Y",
                        saleType: item.saleType,
                      };
                    }
                    return item;
                  }),
                };

                setCart(newCart);
                setSelectedItemsModalOpen(false);

                // 🔥 NEW: CHECK IF ALL ITEMS FIRED
                const allFired = newCart.items.every((i) => i.order === "Y");

                if (allFired) {
                  if (fireMode === "single") {
                    await handleDisplayOk(selectedTable, pendingFireItems);
                  } else {
                    await handleDisplayOk(selectedTable);
                  }
                  return;
                }

                // existing behavior for Fire All button
                if (fireMode === "all") {
                  await handleDisplayOk(selectedTable);
                }
                if (fireMode === "single") {
                  await handleDisplayOk(selectedTable, pendingFireItems);
                  return;
                }
              } finally {
                setConfirmFiring(false);
              }
            }}
          >
            Confirm
          </Button>
        </Row>
      </Modal>
      <Modal open={barcodeOrderStatusModal} closable={false} footer={null} styles={{ body: { padding: 10 } }} onCancel={() => setBarcodeOrderStatusModal(false)}>
        <Row>
          <Col span={12}>
            <p style={data.restaurantPos.content.selectedItemsDisplayModal.title}>Order Details</p>
          </Col>
          <Col span={12}>
            <p style={data.restaurantPos.content.selectedItemsDisplayModal.closeIconP}>
              <CloseOutlined onClick={() => setBarcodeOrderStatusModal(false)} style={data.restaurantPos.content.selectedItemsDisplayModal.closeIcon} />
            </p>
          </Col>
        </Row>
        {barcodeOrderList?.map((item, index) => (
          <Card styles={{ body: { padding: 10 } }} style={data.restaurantPos.content.orderStatusModal.orderItemsCard}>
            <Row style={{ marginBottom: 10 }}>
              <Col span={15} style={{ paddingLeft: 5 }}>
                <p style={data.restaurantPos.content.orderStatusModal.orderCustDetails}>{item.customerName || "Anonymous"}</p>
                <p style={data.restaurantPos.content.orderStatusModal.orderCustDetails}>#{item.orderNo}</p>
                <div style={data.restaurantPos.content.orderStatusModal.timerDiv}>
                  <img src={TimerIcon} alt="Timer Icon" style={{ paddingRight: 5, width: 15 }} />
                  <span style={data.restaurantPos.content.orderStatusModal.orderTime}>00.02</span>
                </div>
              </Col>
              <Col span={6} style={{ textAlign: "center" }}>
                <p style={data.restaurantPos.content.orderStatusModal.orderCustDetails}>{item.dateCreated}</p>
                <p style={data.restaurantPos.content.orderStatusModal.orderCustDetails}>{item.noOfItems} Items</p>
              </Col>
              <Col span={2} style={{ textAlign: "center" }}>
                {/* <AspectRatio ratio={1}> */}
                <img src={MobileIcon} alt="Mobile Icon" style={data.restaurantPos.content.orderStatusModal.mobileIcon} />
                {/* </AspectRatio> */}
              </Col>
              <Col span={1} style={data.restaurantPos.content.orderStatusModal.statusCol}>
                <Badge color={"#EF8354"} />
              </Col>
            </Row>
            <Scrollbars autoHide className="barcodeSelectedItemsScroll">
              <div style={data.restaurantPos.content.orderCart.thirdRow}>
                {item?.lineItems?.map((productItem, index) => (
                  <div
                    style={{
                      padding: "5px 0px",
                      cursor: "pointer",
                    }}
                  >
                    <Row>
                      <Col span={1}>
                        <p style={data.restaurantPos.content.orderCart.productDetails}>{index + 1}</p>
                      </Col>
                      <Col span={14}>
                        <p style={data.restaurantPos.content.orderCart.productDetails}>{productItem?.productAliasName ? productItem?.productAliasName : productItem.name}</p>
                      </Col>
                      <Col span={9}>
                        <p style={data.restaurantPos.content.orderCart.productDetails}>
                          <Row>
                            <Col span={10}>
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}{" "}
                              {Number(sumBy(productItem?.addOnProducts, "price") || 0) + (item.posOrders === "Y" ? productItem.salePrice : productItem.price)}{" "}
                              {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                            </Col>
                            <Col span={5}>X</Col>
                            <Col span={9}>
                              <span style={data.restaurantPos.content.orderCart.productQty}>
                                <span style={data.restaurantPos.content.orderCart.productDetails}>{item.posOrders === "Y" ? productItem.weight : productItem.quantity}</span>
                              </span>
                            </Col>
                          </Row>
                        </p>
                      </Col>
                    </Row>
                    {productItem?.addOnProducts?.map((subitem) => (
                      <div style={data.restaurantPos.content.orderCart.thirdRow}>
                        <Row>
                          <Col span={10} style={data.restaurantPos.content.orderStatusModal.orderModifierCol}>
                            <p style={data.restaurantPos.content.orderCart.modifier}>{subitem.name}</p>
                          </Col>
                          <Col span={14}>
                            <p style={data.restaurantPos.content.orderCart.modifierPrice}>+ {subitem.price}</p>
                          </Col>
                        </Row>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </Scrollbars>
            <Row>
              <Col span={12}>
                <Button size="medium" style={data.restaurantPos.content.barcodeOrderStatusModal.printBtn} className="addButton" onClick={() => handleBarcodeOrderPrint(item)}>
                  <span style={data.restaurantPos.content.barcodeOrderStatusModal.printBtn.label}>Print</span>
                </Button>
              </Col>
              <Col span={12}>
                <Button size="medium" style={data.restaurantPos.content.barcodeOrderStatusModal.acceptBtn} className="addButton" onClick={() => handleAccept(item)}>
                  <span style={data.restaurantPos.content.barcodeOrderStatusModal.acceptBtn.label}>Complete</span>
                </Button>
              </Col>
            </Row>
          </Card>
        ))}
      </Modal>
      <Modal open={billConfirmationModalOpen} closable={false} footer={null} styles={{ body: { padding: 20 } }} width="40%" style={{ top: 200 }}>
        <div>
          <Row>
            <Col span={15}>
              <p style={data.restaurantPos.content.billConfirmationModal.title}>Confirm Bill</p>
            </Col>
            <Col span={9}>
              <p style={retailData.posScreenStyles.offerSelectionModal.closeIconP}>
                <CloseOutlined onClick={() => setBillConfirmationModalOpen(false)} style={retailData.posScreenStyles.offerSelectionModal.closeIcon} />
              </p>
            </Col>
          </Row>
          <Row gutter={[8, 0]}>
            <Col span={12}>
              <Button
                size="medium"
                className="customerDetailsSubmitBtnBtn"
                style={data.restaurantPos.content.billConfirmationModal.billTypeBtn}
                htmlType="submit"
                onClick={handleBillPrint}
              >
                Prepare Bill
              </Button>
            </Col>
            <Col span={12}>
              <Button
                size="medium"
                className="customerDetailsCancelBtn"
                style={data.restaurantPos.content.billConfirmationModal.billTypeBtn}
                onClick={() => {
                  setBillConfirmationModalOpen(false);
                  openPaymentModal();
                }}
              >
                Pay Bill
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
      <Modal open={managementScreenShow} closable={false} footer={null} styles={{ body: { padding: 0 } }}>
        <div className="managementMainDiv">
          <Row>
            <Col span={12}>{/* <p style={retailData.posScreenStyles.offerSelectionModal.title}>Management Options</p> */}</Col>
            <Col span={12}>
              <p style={retailData.posScreenStyles.offerSelectionModal.closeIconP}>
                <CloseOutlined onClick={() => setManagementScreenShow(false)} style={retailData.posScreenStyles.offerSelectionModal.closeIcon} />
              </p>
            </Col>
          </Row>
          <Row gutter={[8, 8]}>
            <Col span={12}>
              <div className="mngBtns" onClick={() => setRefundModalShow(true)}>
                <p style={{ paddingTop: 50 }}>
                  <span className="mngBtnText">Refund</span> <img src={RefundIcon} alt="" className="mngBtnIcon" />
                </p>
              </div>
              <div className="mngBtns">
                <p style={{ paddingTop: 50 }}>
                  <span className="mngBtnText">Print Last Bill</span> <img src={PrintIcon} alt="" className="mngBtnIcon" />
                </p>
              </div>
            </Col>
            <Col span={12}>
              <div className="mngBtns">
                <p style={{ paddingTop: 50 }}>
                  <span className="mngBtnText">Print By Receipt Number</span> <img src={PrintIcon} alt="" className="mngBtnIcon" />
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
      <Modal open={refundModalShow} closable={false} footer={null} width="30%" styles={{ body: { padding: "15px" } }} style={{ top: "40px" }}>
        <Row>
          <Col span={16}>
            <p className="enter-receipt">Enter Receipt Number</p>
          </Col>
          <Col span={8} style={{ alignSelf: "center" }}>
            <CloseOutlined style={{ float: "right", fontSize: "16px", marginTop: "-4px" }} onClick={() => setRefundModalShow(false)} />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Input
              size="large"
              placeholder="Search"
              value={weight}
              onChange={onChangeWeight}
              allowClear={false}
              style={retailData.posScreenStyles.quantityUpdateCard.quantityUpdateInput}
              prefix={<SearchOutlined style={retailData.posScreenStyles.customerModal.searchIcon} />}
            />
          </Col>
          <Col span={24}>
            <div>
              <p className="search-results">Search Results</p>
              <p className="receipt-num" onClick={() => setRefundConfirmModalShow(true)}>
                83292301
              </p>
            </div>
          </Col>
          <Col span={6}>
            <AspectRatio ratio="1">
              <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight("1")}>
                1
              </button>
            </AspectRatio>
          </Col>
          <Col span={6}>
            <AspectRatio ratio="1">
              <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight("2")}>
                2
              </button>
            </AspectRatio>
          </Col>
          <Col span={6}>
            <AspectRatio ratio="1">
              <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight("3")}>
                3
              </button>
            </AspectRatio>
          </Col>
          <Col span={6}>
            <AspectRatio ratio="1">
              <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn}>
                <CloseOutlined style={{ fontSize: "24px" }} />
                {/* <img src={Aclose} style={retailData.posScreenStyles.quantityUpdateCard.qtyBtnClose} alt="close icon" /> */}
              </button>
            </AspectRatio>
          </Col>
          <Col span={6}>
            <AspectRatio ratio="1">
              <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight("4")}>
                4
              </button>
            </AspectRatio>
          </Col>
          <Col span={6}>
            <AspectRatio ratio="1">
              <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight("5")}>
                5
              </button>
            </AspectRatio>
          </Col>
          <Col span={6}>
            <AspectRatio ratio="1">
              <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight("6")}>
                6
              </button>
            </AspectRatio>
          </Col>
          <Col span={6}>
            <AspectRatio ratio="1">
              <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight("x")}>
                <img src={Backspace} alt="back space" style={retailData.posScreenStyles.quantityUpdateCard.qtyBtnBack} />
              </button>
            </AspectRatio>
          </Col>
          <Col span={18}>
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <AspectRatio ratio="1">
                  <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight("7")}>
                    7
                  </button>
                </AspectRatio>
              </Col>
              <Col span={8}>
                <AspectRatio ratio="1">
                  <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight("8")}>
                    8
                  </button>
                </AspectRatio>
              </Col>
              <Col span={8}>
                <AspectRatio ratio="1">
                  <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight("9")}>
                    9
                  </button>
                </AspectRatio>
              </Col>
              <Col span={16}>
                <button className="zeroBtn" style={retailData.posScreenStyles.quantityUpdateCard.quantityBtnZero} onClick={() => handleWeight("0")}>
                  0
                </button>
              </Col>
              <Col span={8}>
                <AspectRatio ratio="1">
                  <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtn} onClick={() => handleWeight(".")}>
                    00
                  </button>
                </AspectRatio>
              </Col>
            </Row>
          </Col>
          <Col span={6}>
            <Row gutter={[16, 16]} style={{ height: "100%" }}>
              <Col span={24}>
                <button style={retailData.posScreenStyles.quantityUpdateCard.quantityBtnOk} onClick={() => addQuantity()}>
                  {/* <AspectRatio ratio="1"> */}
                  <img src={ok} alt="ok" width={40} />
                  {/* </AspectRatio> */}
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal>
      <Modal open={refundConfirmModalShow} closable={false} footer={null} width="30%" style={{ top: "200px" }}>
        <Row>
          <Col span={24} style={{ alignSelf: "center" }}>
            <CloseOutlined style={{ float: "right" }} onClick={() => setRefundConfirmModalShow(false)} />
          </Col>
        </Row>
        <div>
          <Row>
            <Col span={24}>
              <p className="refundModalTitle">Are you sure want a Refund?</p>
            </Col>
          </Row>
          <Row className="refundBtns">
            <Button size="medium" className="refundYesBtn" onClick={() => setRefundRemarksModalShow(true)}>
              Yes
            </Button>
            <Button size="medium" className="refundNoBtn" onClick={() => setRefundConfirmModalShow(false)}>
              No
            </Button>
          </Row>
        </div>
      </Modal>
      <Modal open={refundRemarksModalShow} closable={false} footer={null} styles={{ body: { padding: "15px" } }}>
        <Row style={{ marginBottom: 10 }}>
          <Col span={16}>
            <p className="enter-receipt">Enter Receipt Number</p>
          </Col>
          <Col span={8} style={{ alignSelf: "center" }}>
            <CloseOutlined style={{ float: "right", fontSize: "16px", marginTop: "-4px" }} onClick={() => setRefundRemarksModalShow(false)} />
          </Col>
        </Row>
        <p className="receipt-num" onClick={() => setRefundConfirmModalShow(true)}>
          Reason for refund
        </p>
        <TextArea rows={3} value={keypadInput} onChange={handleRemarksValue} placeholder="Type Here" className="refund-remarks" />
        <Keyboard keyboardRef={(r) => (keyboard.current = r)} layoutName={layout} onChange={handleKeyboardInputs} onKeyPress={handleKeyPress} />
      </Modal>
      <Modal
        open={loyalityOtpModalVisible}
        closable={true}
        onCancel={() => {
          setLoyalityOtpModalVisible(false);
          setLoyaltyPaymentOtp("");
        }}
        footer={null}
        onclosefooter={null}
        width="35%"
        styles={{ body: { padding: "20px 15px 15px" } }}
      >
        <Row style={{ textAlign: "center" }}>Enter OTP</Row>
        <Row style={{ padding: "30px" }}>
          <Col span={20}>
            <Input onPressEnter={processOtpInput} onChange={(e) => setLoyaltyPaymentOtp(e.target.value)} value={loyaltyPaymentOtp} />
          </Col>
          <Col span={4}>
            <Button onClick={processOtpInput}>Verify</Button>
          </Col>
        </Row>
      </Modal>
    </Fragment>
  );
};

export default PointOfSaleRestaurantModals;
